// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  menue: {
    detail: "社交详情",
    porj: "预设方案",
    domesticChance: "国内高增长",
    socialConcept: "社媒概念",
    ECConcept: "电商概念",
    brand: "品牌",
    category: "类目",
    ebay: "ebay高增长概念",
    overseaChance: "海外高增长",
    amazon: "亚马逊高增长概念",
    overseaBrand: "海外高增长品牌",
    overseaCategory: "海外高增长类目",
    mark: "我的关注",
    report: "行业报告",
    set: "设置",
    back_cmi: "返回CMI平台",
    ai: "AI 降本增效",
  },
  topHead: {
    contact_us: "售后支持",
    QRcode_contact: "扫码联系售后人员",
    product_question: "产品使用遇到问题！",
    scan_code: "可扫码申请产品讲解或培训哦～",
    apply_for: "申请讲解/培训",
    select_option_concept: "概念",
    select_option_brand: "品牌",
    select_option_category: "类目",
    select_option_ebay: "Ebay",
    select_option_amazon: "亚马逊",
    select_option_holder: "请选择",
    select_option_concept_holder: "请输入概念词",
    search_tooltip1: "支持使用“and”、“or”、“not”的筛选条件，与概念用空格隔开。",
    search_tooltip2: "如： “小米 and 华为”表示商品标题即包含“小米”又包含“华为”",
    search_tooltip3: "“小米 or 华为 ” 表示商品标题“小米”“华为”至少包含其一",
    search_tooltip4: "“小米 not 华为” 表示商品标题包含“小米”且不包含“华为”",
    my_attention: "我的关注",
    login_label: "登录",
    login_out: "退出",
    Chinese: "中文",
    English: "English",
  },
  mainHead: {
    eidtTooltip: "编辑搜索条件",
    platList_weibo: "微博",
    platList_douyin: "抖音",
    platList_xhs: "小红书",
    dateLabel: "时间",
    date_to: "至",
    date_holder: "选择月",
    saveProj: "保存方案",
    follow: "关注",
    tabs_trend: "概要&趋势",
    tabs_category: "Top类目",
    tabs_category_son: "Top叶子类目",
    tabs_brand: "Top品牌",
    tabs_commodity: "Top商品",
    tabs_baseInfo: "基本信息",
    tabs_talents: "达人榜",
    rules_message_search: "请输入概念词搜索",
    rules_message_search2: "品牌和帖子内容至少有一个不为空",
    rules_message_range: "时间范围不能为空",
    message_saveProj_success: "方案保存成功",
    message_saveProj_failed: "方案保存失败",
  },
  mainHeader: {
    no_discount: "不减优惠券",
    discount_v1: "优惠券模型v1",
    full_discount_v2: "完全减优惠券v2",
  },
  search: {
    title: "添加搜索条件",
    form_postWord: "概念词",
    form_postWord_tip:
      "支持and、or、not逻辑，和分词用空格隔开；例如：口红 and （唇釉 or 唇彩）not 哑光",
    form_brand: "品牌",
    form_brand_holder: "输入品牌关键词",
    form_brand_tip:
      "例如：搜索品牌'苹果/Apple',会筛选出帖子中包含'苹果'或'Apple' 或 '苹果/Apple',且通过语意分析可确定其代表'苹果/Apple' 的帖子。",
    form_plat: "平台",
    form_platOption_douyin: "抖音",
    form_platOption_weibo: "微博",
    form_platOption_xhs: "小红书",
    form_dateRange: "时间范围",
    form_dateRange_holder: "选择月",
    form_dateRange_to: "至",
    searchBtnLab: "搜  索",
    operation: "操作",
  },
  baseInfo: {
    kols: "作者",
    contentForKols: "抖音大于5w，微博大于10w，小红书大于1w",
    trend: "趋势",
    posts: "贴子数",
    posts_toolTip: "总发帖数",
    interaction: "互动量",
    interaction_toolTip: "评论数+点赞数+转发数",
    platTitle: "平台分布",
    cloudWordTitle: "词云图",
    TalentTitle: "达人Top10榜单",
    PostListLabel: "声量排行",
    IteractionListLabel: "互动量排行",
    BrandTitle: "品牌Top10榜单",
    postContent: "帖子原文",
    postType_Forward: "正向",
    postType_back: "负向",
    selectedCondition: "已选中的条件",
    postKeyWordLabel: "概念词：",
    cloudWordLabel: "词云：",
    kolLabel: "KOL：",
    brandLabel: "品牌：",
    brand: "品牌",
    originPostLink: "原文链接",
    negativePostPercent: "负向声量占比",
    reposts: "转发数",
    comments: "评论数",
    zans: "点赞数",
    participle: "分词",
    frequency: "词频",
    photo: "头像",
    Talent: "达人",
    plant: "平台",
    fansNum: "粉丝数",
    downLoad: "下载",
    downLoading: "下载准备中...",
    ranking: "排名",
    cloud_select_word: "词+二元组",
    cloud_nameLabel: "词",
    cloud_valueLabel: "数量",
    category: "类目",
    soldAmount: "销售额",
    sales: "销量",
    itemNum: "宝贝数",
    goodsNum: "商品数",
    shopNum: "店铺数",
    average: "商品均价",
    averagePrice: "均价",
    price: "价格",
    picture: "图片",
    itemTitle: "宝贝标题",
    unfollow: "取消关注",
    yoy_growth: "同比增长率",
    now: "当月总销售额",
    multi_month: "三个月总销售额",
    last: "去年同期销售额",
    lastQuarter: "上一季度同期销售额",
    classification: "分类",
    zero: "无",
    consumer: "消费者",
    contentForConsumer: "粉丝数≤100",
    tipsForFilter: "类目、品牌筛选条件对社交模块不生效",
    contentForTips:
      "如搜索“类目>无糖”或“类目>品牌>无糖”，都是以“无糖”为关键字，搜索包含“无糖”二字的帖子",
    authorNum: "作者数",
    postNum: "声量",
    volumeYoyGrowth: "声量同比增长率",
    likeNum: "点赞数",
    commentNum: "评论数",
    commentYoyGrowth: "评论数同比增长率",
    followerNum: "粉丝数",
    interactionVolume: "互动量",
    interactionYoyGrowth: "互动量同比增长率",
    forwardNum: "转发数",
    productDesc: "商品描述",
    recently: "最近",
    random: "随机",
    thousand: "1,000条",
    tenThousand: "10,000条",
    lakh: "100,000条(较慢)",
  },
  TalentList: {
    allPosts: "全部帖子",
    forwardPosts: "正向帖子",
    backPosts: "负向帖子",
  },
  describeTitle: {
    saleSummary: "销售概要",
    searchCondition: "商品查询条件",
    searchTitleWord: "商品标题包含",
    realCalculate: "实时计算版",
    precomputation: "预计算版",
    inAdvanceText:
      "概念发现阶段我们通过AI算法在海量数据上进行计算，成本昂贵，因此会在计算过程中进行部分近似，从而导致预计算版跟上方实时计算版的数值有一定差别，但此差别不影响对高增长概念的发现和判别。此概念下的具体数据请以上方的实时计算结果为准。",
    socialSummary: "社交概要",
    socialSearchCondition: "社媒查询条件",
    postContent: "帖子内容",
    searchCategoryRange: "搜索类目范围",
    saleTrend: "销售趋势",
    sale: "销售",
    trend: "趋势",
    spreading: "传播力",
    productKeywaod: "商品标题高频关键词",
    socialplatformshare: "社交平台占比",
    highFreWords: "相关高频词组",
    voiceOfReviews: "电商评论各方面声量",
    keywordsOfReviews: "电商评论高频关键词",
  },
  proj: {
    title: "预设方案",
    userDefinedName: "自定义名称",
    postsKeyWords: "帖子关键字",
    brand: "品牌",
    Talent: "达人",
    plant: "平台",
    date: "时间",
    to: " 至 ",
  },
  tableTh: {
    suggest: "标注",
    concept: "概念",
    previous_quarter: "上一季度同期销售额",
    now: "当月总销售额",
    multi_month: "三个月总销售额",
    last: "去年同期销售额",
    yoy_growth: "同比增长率",
    market_growth: "市场增长率",
    commodity_sample: "商品样本",
    average: "商品均价",
    market_average: "市场均价",
    desc: "商品描述",
    trend_chart: "近12个月销售趋势",
    category: "类目",
    route: "路径",
    hierarchy: "层级",
    relevant_category: "相关类目",
    classification: "分类",
    brand: "品牌",
    beyond_market: "超越市场(alpha)",
    category_son: "叶子类目",
  },
  tableThTip: {
    sift: "筛选",
    select_all: "全选",
    confirm: "确定",
    suggest: "标注",
    not_suggest: "未标注",
    recommend: "推荐",
    not_recommend: "不推荐",
    trash_can: "垃圾桶",
    concept_toolTip:
      "在海量商品中多次出现且有明显总销量的字/词组合，不一定是有现存意思的词汇，可能需要分析师结合概念详情来推断和归纳它所揭示的商品特性和机会点。",
    trend_chart_toolTip:
      "标题中包含这个概念的全部商品在当前月份(含)的近12个月的总销售趋势",
    now_toolTip: "标题中包含这个概念词的全部商品在当前月份的总销售额",
    last_toolTip: "标题中包含这个概念词的全部商品在去年的当前月份的总销售额",
    yoy_growth_toolTip: "当月总销售额 / 去年同期销售额 - 1",
    commodity_sample_toolTip:
      "标题中包含这个概念词的部分商品（随机采样），帮助分析师推断此概念实际揭示的商品特性",
    average_toolTip: "标题中包含这个概念词的部分商品（随机采样）的价格平均值",
    desc_toolTip:
      "标题中包含这个概念词的部分商品（随机采样）中提取出来的出现次数高的词，帮助分析师推断此概念实际揭示的商品特性",
    relevant_category_toolTip:
      "此条记录的所有计算是在这个一级类目当中进行而得到的。我们只在每个一级类目下分别发现高增长概念",
    brand_now_toolTip: "此品牌在当前月份的总销售额",
    category_now_toolTip: "此类目在当前月份的总销售额",
    brand_last_toolTip: "此品牌在去年的当前月份的总销售额",
    category_last_toolTip: "此类目在去年的当前月份的总销售额",
    brand_beyond_market_toolTip: "同比增长率 - 市场增长率",
    brand_market_growth_toolTip:
      "此品牌各主营叶子类目总销售额的同比增长率的加权平均值\n例如：\n类目A下有a1、a2两个叶子类目\n某品牌在A类目下销售额共100w，其中:\n- a1销售额40w，权重为0.4\n- a2销售额60w，权重为0.6\n当月各叶子类目增长率为：\n- 叶子类目a1：70%\n- 叶子类目a2：15%\n该品牌在A类目下的市场增长率为：\n0.4*70%+0.6*15%=37%",
    category_market_growth_toolTip: "对应父级类目的总销售额同比增长率",
    brand_market_average_toolTip: "此品牌的市场商品的价格平均值",
    category_market_average_toolTip: "此类目的市场商品的价格平均值",
    previous_quarter_toolTip:
      "标题中包含这个概念词的全部商品在上一季度的对应月份的总销售额",
    ebay_yoy_growth_toolTip: "当月总销售额 / 上季度同期销售额 - 1",
    ebay_market_growth_toolTip:
      "此关键词各主营叶子类目总销售额的同比增长率的加权平均值",
    concept_table_tip:
      "列表页数据为模糊计算，和详情页数据可能有出入，以详情页数据为准",
    volume_char_tip1:
      "全部声量、正向声量、负向声量 括号里的数字是各方面的声量占比。",
    volume_char_tip2:
      "全部声量-方面声量占比：此方面总声量数/全部声量总数*100%。",
    volume_char_tip3:
      "正向声量-方面声量占比：此方面正向声量数/全部正声量数*100%。",
    volume_char_tip4:
      "负向声量-方面声量占比：此方面负向声量数/全部负向声量*100%。",
    volume_char_tip5: "目前仅覆盖天猫或京东平台",
    allVolume: "全部声量",
    posVolume: "正向声量",
    negVolume: "负向声量",
    negRate: "负向率",
    word_cloud_tip1: "词云图有多种生成规则：",
    word_cloud_tip2: "词：将满足筛选条件的声量分句拆分成词。",
    word_cloud_tip3: "二元组：将满足筛选条件的声量分句拆分成相邻2个词的组合。",
    word_cloud_tip4: "示例：声量分句：“京东快递很快”",
    word_cloud_tip5: "按照第一种规则会被拆分为“京东”、“快递”、“很快”3个词。",
    word_cloud_tip6:
      "按照第二种规则会被拆分为“京东快递”、“快递很快”2个二元组。",
  },
  headSearch: {
    // 增加平台选项,可以选择显示淘系或者京东数据
    plat: "平台",
    amazon_us: "亚马逊美国站",
    amazon_jp: "亚马逊日本站",
    shopee_my: "shopee马来西亚站",
    shopee_sg: "shopee新加坡站",
    shopee_id: "shopee印度尼西亚站",
    shopee_ph: "shopee菲律宾站",
    shopee_th: "shopee泰国站",
    shopee_vn: "shopee越南站",
    lazada_my: "lazada马来西亚站",
    lazada_sg: "lazada新加坡站",
    lazada_id: "lazada印度尼西亚站",
    lazada_ph: "lazada菲律宾站",
    lazada_th: "lazada泰国站",
    lazada_vn: "lazada越南站",
    select_option_taobao: "淘宝+天猫",
    select_option_JD: "京东",
    select_option_tbjd: "淘宝+天猫+京东",
    select_option_tbjddy: "淘宝+天猫+京东+抖音",
    select_option_gamazon: "亚马逊",
    select_option_weibo_xhs_douyin: "微博+抖音+小红书",
    select_option_weibo: "微博",
    select_option_douyin: "抖音",
    select_option_xhs: "小红书",
    all: "全部",
    no: "无标签",
    query: "查询",
    monthAll: "当月全部",
    monthAdd: "当月新增",
    recommend: "分析师推荐",
    category: "相关类目",
    month: "月份",
    volumeGrowth: "声量增长率",
    interactionGrowth: "互动增长率",
    monthVolume: "当月声量",
    monthInteraction: "当月互动量",
    lastVolume: "去年同期声量",
    lastInteraction: "去年同期互动量",
    oneMonth: "单月",
    lastThreeMonths: "过去三个月",
    growth: "增长率",
    yoy_growth: "同比增长率",
    volume_yoy_growth: "声量同比增长率",
    interaction_yoy_growth: "互动量同比增长率",
    sales: "当月销售额",
    last_sales: "去年同期销售额",
    name: "名称",
    keyword: "关键字",
    classification: "分类",
    avg_price: "均价",
    average: "商品均价",
    form_category_holder: "请选择类目",
    form_category_loading: "加载中...",
    form_category_select: "请选择",
    form_category_search_holder: "按enter检索",
    form_month_holder: "请选择月份",
    form_keyword_holder: "请输入关键字(多个用空格分隔)",
    form_classification_holder: "请选择分类",
    form_sales_min_holder_concept: "筛选出大于此销售额的概念",
    form_sales_max_holder_concept: "筛选出小于此销售额的概念",
    form_growth_min_holder_concept: "筛选出大于此增长率的概念",
    form_growth_max_holder_concept: "筛选出小于此增长率的概念",
    form_average_min_holder_concept: "筛选出大于此价格的概念",
    form_average_max_holder_concept: "筛选出小于此价格的概念",
    form_sales_min_holder_brand: "筛选出大于此销售额的品牌",
    form_sales_max_holder_brand: "筛选出小于此销售额的品牌",
    form_growth_min_holder_brand: "筛选出大于此增长率的品牌",
    form_growth_max_holder_brand: "筛选出小于此增长率的品牌",
    form_average_min_holder_brand: "筛选出大于此价格的品牌",
    form_average_max_holder_brand: "筛选出小于此价格的品牌",
    form_sales_min_holder_category: "筛选出大于此销售额的类目",
    form_sales_max_holder_category: "筛选出小于此销售额的类目",
    form_growth_min_holder_category: "筛选出大于此增长率的类目",
    form_growth_max_holder_category: "筛选出小于此增长率的类目",
    form_average_min_holder_category: "筛选出大于此价格的类目",
    form_average_max_holder_category: "筛选出小于此价格的类目",
    form_placeholder_10k: "万元",
    form_placeholder_unit: "元",
  },
  footer: {
    content_one:
      "魔镜洞察的数据全部来自公开页面，魔镜洞察与淘宝、天猫、京东、亚马逊等电商平台无直接关联，是一家独立的第三方电商数据机构",
    content_two: "@2025 北京淘幂科技有限公司 ",
    content_icp: "京ICP备15061734号-4 ",
    content_goan: "京公网安备11010502037832号 ",
    content_add:
      "数据由公开页面采集并汇总处理，数据口径和平台及其他机构有所不同，仅供参考，如有差异请以平台官方发布数据为准",
  },
  setting: {
    phone_set: "手机号设置",
    mail_set: "邮箱设置",
    primary_number: "您的主手机号",
    mail_number: "您的邮箱号",
    second_number: "您的辅手机号",
    delete: "删除",
    phone_placeholder: "请输入内容",
    sms: "短信登录验证",
    add: "添加手机",
    add_mail: "添加邮箱",
    success: "手机号添加成功",
    confirm: "确 定",
    dialog_phone: "主手机号",
    dialog_input_placeholder: "输入验证码",
    verification: "验证",
    cancel: "取消",
    yesterday: "昨天",
    7: "近7天",
    30: "近30天",
    90: "近90天",
    enter_num: "请输入手机号",
    enter_mail: "请输入邮箱号",
    enter_correct_num: "请输入正确的手机号",
    enter_correct_mail: "请输入正确的邮箱",
    first_num: "第一个手机号必须开启短信登录验证",
    note: "备注",
    optional: "备注(选填)",
    desc: "海外手机号填写格式: +区号 手机号",
    example: "如: +852 61234567",
  },
};
